"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ruleSet = _interopRequireDefault(require("@vfuk/source-system-icons/dist/ruleSet"));

var _ruleSet2 = _interopRequireDefault(require("@vfuk/source-hifi-dark-icons/dist/ruleSet"));

var _ruleSet3 = _interopRequireDefault(require("@vfuk/source-hifi-light-icons/dist/ruleSet"));

var _ruleSet4 = _interopRequireDefault(require("@vfuk/source-mid-render-light-icons/dist/ruleSet"));

var _ruleSet5 = _interopRequireDefault(require("@vfuk/source-mid-render-dark-icons/dist/ruleSet"));

var _ruleSet6 = _interopRequireDefault(require("@vfuk/source-tobi-icons/dist/ruleSet"));

var _ruleSet7 = _interopRequireDefault(require("@vfuk/brand-lofi-icons/dist/ruleSet"));

var _ruleSet8 = _interopRequireDefault(require("@vfuk/source-state-icons/dist/ruleSet"));

var _ruleSet9 = _interopRequireDefault(require("@vfuk/source-flag-icons/dist/ruleSet"));

var _ruleSet10 = _interopRequireDefault(require("@vfuk/uk-legacy-icons/dist/ruleSet"));

var _ruleSet11 = _interopRequireDefault(require("@vfuk/brand-hifi-icons/dist/ruleSet"));

var _ruleSet12 = _interopRequireDefault(require("@vfuk/source-payment-icons/dist/ruleSet"));

var _ruleSet13 = _interopRequireDefault(require("@vfuk/uk-brand-icons/dist/ruleSet"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var iconRules = {
  system: {
    assetLocation: 'SourceSystemIcons',
    properties: _ruleSet["default"]
  },
  state: {
    assetLocation: 'SourceStateIcons',
    properties: _ruleSet8["default"]
  },
  hifiDark: {
    assetLocation: 'SourceHiFiDarkIcons',
    properties: _ruleSet2["default"]
  },
  hifiLight: {
    assetLocation: 'SourceHiFiLightIcons',
    properties: _ruleSet3["default"]
  },
  midLight: {
    assetLocation: 'SourceMidRenderLightIcons',
    properties: _ruleSet4["default"]
  },
  midDark: {
    assetLocation: 'SourceMidRenderDarkIcons',
    properties: _ruleSet5["default"]
  },
  brandLofi: {
    assetLocation: 'BrandLoFiIcons',
    properties: _ruleSet7["default"]
  },
  chatbot: {
    assetLocation: 'SourceTobiIcons',
    properties: _ruleSet6["default"]
  },
  flag: {
    assetLocation: 'SourceFlagIcons',
    properties: _ruleSet9["default"]
  },
  ukLegacy: {
    assetLocation: 'UkLegacyIcons',
    properties: _ruleSet10["default"]
  },
  brandHifi: {
    assetLocation: 'BrandHiFiIcons',
    properties: _ruleSet11["default"]
  },
  payment: {
    assetLocation: 'SourcePaymentIcons',
    properties: _ruleSet12["default"]
  },
  ukBrand: {
    assetLocation: 'UkBrandIcons',
    properties: _ruleSet13["default"]
  }
};
var _default = iconRules;
exports["default"] = _default;
//# sourceMappingURL=iconRules.js.map